import type { InjectionKey } from 'vue'

import type { IGtagPlugin } from './gtag.types'

export const GtagKey: InjectionKey<IGtagPlugin> = Symbol('gtag')
